import { SideImage } from '../../components/SideImage';
import { StickyFooter } from '../../components/StickyFooter';
import { SpaDaysBookingContent } from '../../composites/SpaDaysBookingContent';
import { SplitLayout } from '../../composites/SplitLayout';
import { HideOnMobile } from './SpaDaysBookingForm.styles';
import type { SpaDaysBookingFormProps } from './SpaDaysBookingForm.types';

export function SpaDaysBookingForm({
  imageUrl,
  imageAlt,
  onBack,
  stickyFooter,
  labels,
  ...contentProps
}: SpaDaysBookingFormProps) {
  const {
    title,
    subtitle,
    calendar,
    timeslotChips,
    stickyFooter: stickyFooterLabels,
    ...contentLabels
  } = labels;

  return (
    <SplitLayout
      left={
        <HideOnMobile>
          <SideImage src={imageUrl} alt={imageAlt} sticky onBack={onBack} />
        </HideOnMobile>
      }
      right={
        <>
          <SpaDaysBookingContent
            {...contentProps}
            title={title}
            subtitle={subtitle}
            calendarLabels={calendar}
            labels={{ ...contentLabels, timeslotChips }}
          />
          {stickyFooter && stickyFooterLabels && (
            <StickyFooter
              {...stickyFooter}
              totalLabel={stickyFooterLabels.totalLabel}
              ctaLabel={stickyFooterLabels.ctaLabel}
            />
          )}
        </>
      }
      contentGap="0px"
      contentMaxWidth="100%"
    />
  );
}
